module.exports = __webpack_public_path__ + "img/nature-37.a6425191.jpg";